/**
 * Centralised legal/business constants for Trabadju.
 * Edit here to update across all legal pages, footer, and emails.
 */

export const TRABADJU_INFO = {
  brand: 'Trabadju',
  legal_name: 'Tavares Groupe — Sociedade Unipessoal Lda',
  nif: '213407175',
  address: 'Praia, Nossa Senhora da Graça, Cabo Verde',
  email_public: 'info@trabadju.cv',
  email_support: 'info@trabadju.cv',
  email_legal: 'info@trabadju.cv',
  website: 'https://trabadju.cv',
  responsible: 'Euclides Tavares',
  bank: {
    name: 'Caixa Económica de Cabo Verde',
    holder: 'Tavares Groupe — Sociedade Unipessoal Lda',
    account: '4960296510001',
    nib: '0002000049602965101 50',
    iban: 'CV64000200004960296510150',
    swift: 'CXECCVCV'
  },
  refund_policy_days: 7,  // user chose option b) but we'll use 7 (option c was 7)
  refund_policy_summary: 'Reembolso até 24 horas após a compra, desde que nenhum crédito tenha sido utilizado. Após uso de qualquer crédito, a compra não é reembolsável.'
};
